import _cloneDeep from 'lodash/cloneDeep';

export default {
  merchantsTypeCodeResults: (state) => _cloneDeep(state.merchantsTypeCodeResults),
};
